import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TwoColumns from "@/components/TwoColumns";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEOHead 
        title="Central TG - JAX® 모델 공식 대리점"
        description="미국 JAX transgenic 모델 한국 공식 대리점. 암·신경과학·면역학·당뇨병 연구를 지원합니다."
        keywords="JAX 모델, transgenic 마우스, 실험동물 수입, Jackson Laboratory, 암 연구, 신경과학, 면역학, 당뇨병 연구, USDA 인증, AAALAC, 실험동물, 유전자변형동물, 연구동물, 바이오의학연구, 전임상연구"
        canonical="https://centraltg.co.kr/"
      />
      <Header />
      <Hero />
      <TwoColumns />
      <Footer />
    </div>
  );
};

export default Index;
